import React from 'react';

import SimplePrompt from 'components/layout/SimplePrompt';

export default class CmsRemoveElement extends React.Component {
  render() {
    const { onSuccess } = this.props;

    return (
      <div class="m-t-50 text-right" style={{ position: 'relative' }}>
        <SimplePrompt onSuccess={onSuccess} container={this} />
      </div>
    );
  }
}
